import useClientMutation from '../../common/useClientMutation';
import { USER_REGISTRATION } from '../../consts';
export default function useMiniregRegistration(props) {
    return useClientMutation({
        cacheKey: 'userRegistration',
        url: USER_REGISTRATION,
        fetchOptions: {
            method: 'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json'
            }
        },
        clientOptions: {
            useErrorBoundary: false,
            retry: false,
            cacheTime: 0,
            onSuccess: props?.onSuccess,
            onError: props?.onError
        },
        transformResponse: (result)=>{
            return {
                ...result,
                status: result['login-status'],
                success: result.success === true || result.success === 'true',
                ...Array.isArray(result.message) ? {
                    message: undefined,
                    messages: result.message
                } : typeof result.message === 'string' ? {
                    message: undefined,
                    messages: [
                        result.message
                    ]
                } : {}
            };
        }
    });
}

//# sourceMappingURL=useMiniregRegistration.js.map